export default function openApp(path: string) {
  try {
    const isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

    if (isAndroid || isIOS) {

      if (window.confirm('Wil je dit via de app regelen?')) {
        window.location.href = "de-grote-verleiding://" + path;
      }
      
      
    }
  } catch (e) {
    console.log("can not open native app", e);
  }
}
